import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ContactModal from "../ContactModal/ContactModal";
import "./BuiltForYou.scss";

const BuiltForYou = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  return (
    <Container fluid className="built-wrapper white">
      <Container>
        <Row className="justify-content-center pb-4">
          <Col xs={12} md={12}>
            <h2 className="skewed">Built for U.S. Brands — and Beyond</h2>
            <p>
              Klean Leaf started out with North American businesses in mind,
              offering clear communication, rapid turnaround, and a partner who
              “speaks your language” — literally and professionally. Today,
              our U.S.-based team works hand-in-hand with clients from Europe,
              Australia, Japan, Korea and beyond, so you get the same reliable
              sourcing, streamlined scaling, and local-market expertise no
              matter where you’re selling.
            </p>
            <div className="built-button">
              <button
                className="secondary-btn"
                type="button"
                onClick={showModal}
              >
                Talk to Our Ohio-Based Team
              </button>
            </div>
          </Col>
        </Row>
      </Container>

      <ContactModal
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        idPrefix="built-for-you-contact"
      />
    </Container>
  );
};

export default BuiltForYou;
